<template>
  <div class="general-spinner">
    <div class="loadingio-spinner-rolling-rbsd7qu9x07">
      <div class="ldio-rvqf9xyvmmb">
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'general-spinner',
};
</script>

<style scoped>
@keyframes ldio-rvqf9xyvmmb {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.ldio-rvqf9xyvmmb div {
  position: absolute;
  width: 3.75rem;
  height: 3.75rem;
  border: 0.625rem solid #a9a9a9;
  border-top-color: transparent;
  border-radius: 50%;
}
.ldio-rvqf9xyvmmb div {
  animation: ldio-rvqf9xyvmmb 1s linear infinite;
  top: 3.125rem;
  left: 3.125rem;
}
.loadingio-spinner-rolling-rbsd7qu9x07 {
  width: 3.1875rem;
  height: 3.1875rem;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-rvqf9xyvmmb {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(0.51);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-rvqf9xyvmmb div {
  box-sizing: content-box;
}
/* generated by https://loading.io/ */
</style>
